export default __webpack_public_path__ + "static/directionSub-6c6c379b6ab712f77c450328f3580a4a.jpg";